export const queryKeys = {
  WEBSITE_BLOCK_FLOOR_STATISTIC: 'WEBSITE_BLOCK_FLOOR_STATISTIC',
  WEBSITE_BLOCK_FLAT_DATA: 'WEBSITE_BLOCK_FLAT_DATA',
  WEBSITE_BLOCK_ID_FLOOR_EMPTY_FLAT_COUNT: 'WEBSITE_BLOCK_ID_FLOOR_EMPTY_FLAT_COUNT'
};
